/**
 * @file IdPickField.tsx
 * @description «Выбрать вручную» для элементов секции (phase19.16 Р2;
 * uiux-design-r2 §4 «Товары» ASCII: «[+ Добавить товар] — список с ⋮⋮ и
 * ✕»): выбранное перетаскивается, добавляется поиском по списку магазина
 * (`usePickList`). Удалённая сущность показывается «нет в магазине» — на
 * сайте она скрывается сама (ссылки без FK).
 */

import { Combobox } from "../../../ui/combobox";
import { SortableList } from "./SortableList";
import { usePickList, type PickListKey } from "../../../../hooks/site-builder/usePickList";

interface Props {
  label: string;
  list: PickListKey;
  ids: readonly string[];
  max: number;
  onChange: (ids: string[]) => void;
  /** «Добавить товар». */
  addPlaceholder: string;
  error?: string | null;
}

export function IdPickField({ label, list, ids, max, onChange, addPlaceholder, error }: Props) {
  const { options, failed } = usePickList(list);
  const labelOf = (id: string) => options?.find((o) => o.id === id)?.label ?? (options ? "нет в магазине — на сайте не покажется" : "…");
  const free = (options ?? []).filter((o) => !ids.includes(o.id));
  return (
    <div className="flex flex-col gap-2">
      <SortableList<string> label={label} items={ids} max={max} onChange={onChange} summary={(id) => labelOf(id)} />
      {failed ? <p className="type-caption text-on-surface-variant">Не удалось загрузить список. Проверьте связь и откройте панель ещё раз.</p> : null}
      {ids.length < max && !failed ? (
        <Combobox
          ariaLabel={addPlaceholder}
          options={free.map((o) => ({ value: o.id, label: o.label, description: o.description || undefined }))}
          value={null}
          placeholder={options ? addPlaceholder : "Загружаем…"}
          invalid={!!error}
          onChange={(id) => id && onChange([...ids, id])}
        />
      ) : null}
      {error ? <p className="type-caption text-destructive">{error}</p> : null}
    </div>
  );
}
